import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/api/auth/auth.service";

export const entityGuard: CanActivateFn = (route, state) => {
  // Inject AuthService and Router
  const authService = inject(AuthService);
  const router = inject(Router);
  if (authService.hasRole("ENTITY")) {
    return true;
  } else {
    router.navigate(["/signup"]);
    return false;
  }
};
